import { useAtomValue } from "jotai";
import type { FunctionComponent, ReactElement, SuspenseProps } from "react";
import { useEffect, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { ClientSideSuspense } from "shared/components/common/client-side-suspense";

import { appAtom } from "scmp-app/lib/app/atoms";
import { rosettaAtom } from "scmp-app/lib/rosetta";

import { PlusPaywallSuspenseContent } from "./content";

export const PlusPaywallSuspense: FunctionComponent<SuspenseProps> = ({ children, fallback }) => {
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const hasPianoExperienceExecuted = asyncRosettaState?.result?.hasPianoExperienceExecuted ?? false;
  const { navigatorInfo } = useAtomValue(appAtom);
  const isLightHouseCrawler = navigatorInfo?.isLightHouseCrawler;
  const isContentLoading = !hasPianoExperienceExecuted && !isLightHouseCrawler;

  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) return fallback;

  return (
    <ErrorBoundary fallback={fallback as ReactElement}>
      <ClientSideSuspense fallback={fallback}>
        <PlusPaywallSuspenseContent isContentLoading={isContentLoading}>
          {children}
        </PlusPaywallSuspenseContent>
      </ClientSideSuspense>
    </ErrorBoundary>
  );
};

PlusPaywallSuspense.displayName = "PlusPaywallSuspense";
